const type = 'standard'
const path = '/standard/html-python/'
const name = 'server.py'

export { type, path, name }
